
import { Vue, Component } from "vue-property-decorator"
import api from "../honcierge-api"

@Component
export default class AdsTxt extends Vue {
  private adsTxt = ""

  public created(): void {
    api
      .getAdsTxt()
      .then((response) => {
        this.adsTxt = response.data.adsTxt
      })
      .catch(() => {
        this.$toasted.error("ads.txtの取得に失敗しました")
      })
  }

  private updateAdsTxt() {
    api
      .updateAdsTxt(this.adsTxt)
      .then((response) => {
        console.log(response.data)
        this.adsTxt = response.data.adsTxt
        this.$toasted.success("ads.txtを更新しました")
      })
      .catch(() => {
        this.$toasted.error("ads.txtの更新に失敗しました")
      })
  }
}
